"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConstellationsModule = void 0;
const common_1 = require("../../../common");
class ConstellationsModule extends common_1.APIModule {
    constructor(client) {
        super(client, '/constellations');
    }
    createConstellation(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([]);
            const response = yield this.client.post(endpoint, payload);
            return response.data;
        });
    }
    updateConstellation(constellationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([constellationId]);
            const response = yield this.client.put(endpoint, payload);
            return response.data;
        });
    }
    deleteConstellation(constellationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([constellationId]);
            const response = yield this.client.delete(endpoint);
            return response.data;
        });
    }
    getEvents(constellationId) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([constellationId, 'events']);
            const response = yield this.client.get(endpoint);
            return response.data;
        });
    }
    getEventsCount(constellationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([constellationId, 'events', 'count']);
            const response = yield this.client.get(endpoint, { params: payload });
            return response.data;
        });
    }
    archiveConstellation(constellationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([constellationId, 'archive']);
            const response = yield this.client.put(endpoint, { params: payload });
            return response.data;
        });
    }
    unarchiveConstellation(constellationId, payload) {
        return __awaiter(this, void 0, void 0, function* () {
            const endpoint = this.buildEndpoint([constellationId, 'unarchive']);
            const response = yield this.client.put(endpoint, { params: payload });
            return response.data;
        });
    }
}
exports.ConstellationsModule = ConstellationsModule;
